// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__aGhS9","total":"Cart_total__zg4mS","actions":"Cart_actions__k5E42","button--alt":"Cart_button--alt__TUm2-","button":"Cart_button__Qyn-G"};